/**
 * 匿名コンサルホットライン相談投稿画面の共通文言
 */
export const hotlineConsultantCreateText = {
    /**
     * 項目の名前
     */
    label: {
        adviceRequest: () => '期待するアドバイス',
        description: () => '相談の背景',
        disclose: () => '企業名の開示',
        industry: () => '業界',
        interviewRequestedAt: () => '相談希望日',
        interviewRequestedFromAt: () => '相談希望開始日',
        interviewRequestedToAt: () => '相談希望終了日',
        requestDeadlineAt: () => '回答期限',
        sales: () => '企業規模',
        title: () => '相談タイトル',
    },
};
